<template>
  <div>
    <fccTitlePage :titlePage="titlePage"></fccTitlePage>

    <div class="row mb-5">
      <div class="col">
        <fcc-kanban
          :colunas="colunasKanban"
          :original-items="itemsKanban"
          add-button-text="Adicionar Etapa"
          column-field="tpsituacaodetalhe"
          @adicionar-item="adicionarEtapa"
          @edit-item="editItem"
          @delete-item="deleteItem"
          @item-movido="itemMovido"
        />
      </div>
    </div>

    <fcc-modal-etapa
      :project-id="projectId"
      :etapa-tp="etapaTp"
      :acao-etapa="acaoEtapa"
      :item="itemSelecionado"
      @salvo="atualizarLista"
    />
  </div>
</template>
<script>
import fccModalEtapa from './fccModalEtapa'
import fccKanban from './fccKanban.vue'
import store from '@/store'
import { mapState } from 'vuex'
import { acaoConstantes } from '../constants'
import axios from 'axios'

export default {
  components: { fccModalEtapa, fccKanban },
  props: {
    projectId: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      titlePage: 'Etapas',
      etapaTp: 0,
      itemSelecionado: null,
      acaoEtapa: acaoConstantes.ADICIONAR
    }
  },
  computed: {
    ...mapState('acompanhamentoDeProjetos', ['etapas', 'situacoesDetalhe']),
    colunasKanban() {
      return this.situacoesDetalhe.map((situacao) => ({ ...situacao, titulo: situacao.descricao }))
    },
    itemsKanban() {
      return this.colunasKanban.map((coluna) => {
        return this.etapas?.filter((etapa) => etapa.tpsituacaodetalhe === coluna.tpsituacaodetalhe)
      })
    }
  },
  mounted() {
    store
      .dispatch(
        'acompanhamentoDeProjetos/fetchEtapas',
        this.projectId,
        this.dadosLoginSession.fccTokenHeaders
      )
      .catch(this.setErrorSystem)
  },
  methods: {
    adicionarEtapa(etapa) {
      this.etapaTp = etapa?.tpsituacaodetalhe
      this.acaoEtapa = acaoConstantes.ADICIONAR
      this.$root.$emit('bv::show::modal', 'modal-etapa')
    },
    editItem(item) {
      this.itemSelecionado = item
      this.acaoEtapa = acaoConstantes.EDITAR
      this.$root.$emit('bv::show::modal', 'modal-etapa')
    },
    itemMovido(item) {
      const payload = {
        ...item.obj,
        tpSituacaoDetalhe: this.colunasKanban[item.columnId - 1]?.tpsituacaodetalhe
      }
      axios
        .put(
          store.state.baseUrlGestaoProjetos + 'ProjetoDetalhe/Alterar',
          payload,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then(() => this.atualizarLista(false))
        .catch(this.setErrorSystem)
    },
    deleteItem(item) {
      this.callConfirm(this.mensagemExcluir + ' a etapa?', item.detalhe).then((result) => {
        if (result.value) {
          this.carregaTexto(this.codeMensagem('C01'))
          this.excluirDetalhe(item.iddetalhe)
            .then(() => {
              this.carregaTexto()
              this.callToast(this.mensagensUpdate.excluido, 'success')
              this.atualizarLista()
            })
            .catch(this.setErrorSystem)
        }
      })
    },
    excluirDetalhe(idDetalhe) {
      return new Promise((resolve) => {
        axios
          .delete(
            store.state.baseUrlGestaoProjetos + `ProjetoDetalhe/Excluir/${idDetalhe}`,
            this.dadosLoginSession.fccTokenHeaders
          )
          .then(resolve)
      })
    },
    atualizarLista(loading = true) {
      if (loading) this.carregaTexto(this.codeMensagem('C01'))
      store
        .dispatch(
          'acompanhamentoDeProjetos/fetchEtapas',
          this.projectId,
          this.dadosLoginSession.fccTokenHeaders
        )
        .catch(this.setErrorSystem)
        .finally(() => {
          if (loading) this.carregaTexto()
        })
    }
  }
}
</script>